import React from 'react'
import { noop } from 'lodash'

export const TutorialTooltipGroupContext = React.createContext({
  handleNext: noop,
  handleClose: noop,
  showTooltip: false,
  tutorialStatus: {
    current: 0,
    total: 0,
  },
})
